var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationIconInboxMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#88592F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22L37.6362 24.004C37.704 25.0017 38.4983 25.796 39.496 25.8638L41.5 26L39.496 26.1362C38.4983 26.204 37.704 26.9983 37.6362 27.996L37.5 30L37.3638 27.996C37.296 26.9983 36.5017 26.204 35.504 26.1362L33.5 26L35.504 25.8638C36.5017 25.796 37.296 25.0017 37.3638 24.004L37.5 22Z",
    fill: "#F1BA88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 29L8.16802 31.4722C8.23583 32.4699 9.03011 33.2642 10.0278 33.332L12.5 33.5L10.0278 33.668C9.03011 33.7358 8.23583 34.5301 8.16802 35.5278L8 38L7.83198 35.5278C7.76417 34.5301 6.96989 33.7358 5.9722 33.668L3.5 33.5L5.9722 33.332C6.96989 33.2642 7.76417 32.4699 7.83198 31.4722L8 29Z",
    fill: "#F1BA88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0L7.76348 3.87674C7.83129 4.87443 8.62557 5.66871 9.62326 5.73652L13.5 6L9.62326 6.26348C8.62557 6.33129 7.83129 7.12557 7.76348 8.12326L7.5 12L7.23652 8.12326C7.16871 7.12557 6.37443 6.33129 5.37674 6.26348L1.5 6L5.37674 5.73652C6.37443 5.66871 7.16871 4.87443 7.23652 3.87674L7.5 0Z",
    fill: "#D38B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 14.3438L13.7812 13.2812C13.3094 12.8094 12.5 13.1438 12.5 13.8094V17.25C12.5 17.6656 12.8344 18 13.25 18H16.6906C17.3594 18 17.6938 17.1906 17.2219 16.7188L16.2594 15.7562C17.3438 14.6719 18.8438 14 20.5 14C23.8125 14 26.5 16.6875 26.5 20C26.5 23.3125 23.8125 26 20.5 26C19.225 26 18.0438 25.6031 17.0719 24.925C16.6188 24.6094 15.9969 24.7188 15.6781 25.1719C15.3594 25.625 15.4719 26.2469 15.925 26.5656C17.225 27.4688 18.8031 28 20.5 28C24.9187 28 28.5 24.4187 28.5 20C28.5 15.5813 24.9187 12 20.5 12C18.2906 12 16.2906 12.8969 14.8438 14.3438ZM20.5 16C20.0844 16 19.75 16.3344 19.75 16.75V20C19.75 20.2 19.8281 20.3906 19.9688 20.5312L22.2188 22.7812C22.5125 23.075 22.9875 23.075 23.2781 22.7812C23.5687 22.4875 23.5719 22.0125 23.2781 21.7219L21.2469 19.6906V16.75C21.2469 16.3344 20.9125 16 20.4969 16H20.5Z",
    fill: "#F2C49B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIconInboxMessages);
export default __webpack_public_path__ + "static/media/Conversation_icon_inbox_messages.e1b2ff74a6fecd855a74ab0d366c260c.svg";
export { ForwardRef as ReactComponent };